import ko from 'knockout';
import logger from '../Utils/logger';
import config from '../config';
import contextData from '../contextData';

class LanguageHelper {

  /**
   * Gets current selected language resourceKey
   * @return {string}
   */
  getCurrentLanguageResourceKey = () => {
    if (!contextData.languageCode()) {
      return '';
    }

    const languages = this.getSupportedLanguages();

    const foundLanguage = ko.utils.arrayFirst(languages,
      function (item) {
        return item.languageCode === contextData.languageCode();
      });

    if (!foundLanguage) {
      logger.error('LanguageIsNotSupported', null, contextData.languageCode);

      return '';
    }

    return foundLanguage.resourceKey;
  };

  /**
   * Gets languages list. Filters out TestLanguage if in ReleaseMode
   * @return {array}
   */
  getSupportedLanguages = () => {

    let languages = config.supportedLanguages;

    if (contextData.inReleaseMode) {
      languages = languages.filter(function (item) {
        return item.resourceKey !== 'LanguageNameTestLanguage';
      });
    }

    return languages;
  };

  getAvailableLanguages = (availableLanguageCodes: string[]) => {
    // If the list of available languages is empty then the list is not being controlled via the
    // system setting "AvailableLanguageCodes" so allow access to all supported languages.
    if (!availableLanguageCodes?.length) {
      return config.supportedLanguages;
    }

    return config.supportedLanguages.filter(available => availableLanguageCodes.includes(available.languageCode));
  }
}

export default new LanguageHelper();
